/**
 * <TutorSamSummarySheet> — « Lire le résumé » : les points d'avancement de Sam avec un élève (template).
 *
 * L'ancien `AgentSummaryModal`, ouvert depuis une carte « Sam s'en occupe » du fil : « Points
 * d'avancement » (le prénom passe dans la phrase de Sam : l'en-tête d'une feuille ne tient pas un titre
 * long), Sam qui se présente au masteur (« Je suis Sam, ton assistant… »), puis
 * une carte par échange (`<TutorSamSummaryCard>`), la plus récente d'abord. Rien encore : « Aucun point
 * d'avancement disponible pour le moment. » Ouvrir la feuille marque les échanges lus (un effet de
 * l'écran).
 *
 * Une feuille (`<Modal>`) : basse sur un téléphone, une carte au milieu sur un grand écran.
 */
import React from "react"

import { type UICorrectionFeedback } from "../../../ports/primary/ui/types/studentActivity"
import { type UITutorSamSummary } from "../../../ports/primary/ui/types/tutorLive"
import { Stack } from "../../atoms/containers/Stack"
import { EmptyState } from "../../molecules/EmptyState"
import { Modal } from "../../molecules/Modal"
import { TutorSamSummaryCard } from "../../molecules/TutorSamSummaryCard"
import { ChampionSays } from "../../molecules/ChampionSays"

export type TutorSamSummarySheetProps = {
    visible: boolean
    onClose: () => void
    studentName: string
    summaries: UITutorSamSummary[]
    onOpenPhoto: (summaryId: string, uri: string) => void
    onFeedback: (summaryId: string, feedback: UICorrectionFeedback) => void
    testID?: string
}

const TEXTS = {
    title: "Points d'avancement",
    intro: (name: string) =>
        `Je suis Sam, ton assistant : je suis là pour te relayer si besoin. Retrouve ici les résumés de mes échanges avec ${name}.`,
    emptyTitle: "Rien pour l'instant",
    empty: "Aucun point d'avancement disponible pour le moment.",
}

export function TutorSamSummarySheet(props: TutorSamSummarySheetProps) {
    const { visible, onClose, studentName, summaries, onOpenPhoto, onFeedback, testID } = props
    return (
        <Modal visible={visible} onClose={onClose} title={TEXTS.title} sizeToContent testID={testID}>
            <Stack gap="4">
                <ChampionSays message={TEXTS.intro(studentName)} />
                {summaries.length === 0 ? (
                    <EmptyState title={TEXTS.emptyTitle} message={TEXTS.empty} iconName="comment-dots" />
                ) : (
                    summaries.map((summary) => (
                        <TutorSamSummaryCard
                            key={summary.id}
                            summary={summary}
                            onOpenPhoto={(uri) => onOpenPhoto(summary.id, uri)}
                            onFeedback={(feedback) => onFeedback(summary.id, feedback)}
                        />
                    ))
                )}
            </Stack>
        </Modal>
    )
}
